import styled from 'styled-components';

export const BreadCrumbWrapDiv = styled.div(
  props => `
    display:flex;
    z-index: ${props.theme.misc.zIndex.xlarge};
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    max-width: 120rem;
    padding-top:${props.theme.spacing.small.s5};
    padding-bottom:${props.theme.spacing.large.l15};
    background-color: ${props.theme.colors.blue.brand};
    margin: 0 auto;
  `
);

export const BreadCrumbLeftWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:82%;
    padding-right:${props.theme.spacing.large.l20};
  `
);

export const BreadCrumbLeftWrapInnerDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:100%;
  `
);

export const BackHotelDetailWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
  `
);

export const ReviewBookingTextPara = styled.p(
  props => `
    font-size:${props.theme.font.large.font22};
    color:${props.theme.colors.white.base};
    font-family:${props.theme.font.fontFamily};
    font-weight: bold;
    padding-top: ${props.theme.spacing.large.l15};
    padding-bottom: ${props.theme.spacing.small.s5};
  `
);
